export * from "./customer-eav-attribute";
